import {message} from 'antd';
import {IInvitation, IResponse, IResult, ISignUpEmail, IUserProfile} from '../../types/api';
import Api, {axiosInstance} from '../Api';

export type AntiForgeryToken = {
  requestToken: string,
  header: string,
  cookieToken: string
}

export default class Auth {
  endPoint = 'auth';

  async signUp(props: ISignUpEmail) {
    const payload = {
      email: props.email
    };
    return axiosInstance
      .post<IResponse<any>>(`${Api.SERVER_DOMAIN + Api.IISSite}/${this.endPoint}/signup`, payload)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async invitationComplete(props: IInvitation) {
    const payload = {
      ...props
    };

    return axiosInstance
      .post<IResponse<any>>(`${Api.SERVER_DOMAIN + Api.IISSite}/${this.endPoint}/invitation`, payload).then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  register(props: IUserProfile) {
    const payload = {
      ...props,
      domain: 'MOOD',
      email: props.userId,
      zipCode: props.zipcode,
      shipCountry: props.countryId,
      companyInfo: {
        companyId: props.companyId,
        address1: props.address1,
        address2: props.address2 ? props.address2 : '',
        address3: props.address3 ? props.address3 : '',
        city: props.city,
        postalcode: props.zipcode,
        countryId: props.countryId ? props.countryId : '',
        stateId: props.stateId ? props.stateId : '',
        sizeId: props.sizeId ? props.sizeId : '',
        segmentId: props.segmentId ? props.segmentId : '',
        vatNumber: props.companyId ? props.companyId : '',
        phone: props.phone ? props.phone : '',
      },
    };
    return axiosInstance
      .post<IResponse<any>>(`/${this.endPoint}/Register`, payload)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async GetUserSubscription() {
    return axiosInstance
      .get<IResult<string>>(`/${this.endPoint}/GetUserSubscription`)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async GetDownloaderApiKey() {
    return axiosInstance
      .post<IResult<string>>(`/${this.endPoint}/GetDownloaderAPIKey`)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async getExpirationDate() {
    return axiosInstance
      .get<string>(`${Api.SERVER_DOMAIN + Api.IISSite}/${this.endPoint}/getSessionExpiration`)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }

  async keepSessionActive() {
    return axiosInstance
      .get<string>(`${Api.SERVER_DOMAIN + Api.IISSite}/${this.endPoint}/keepSessionActive`)
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      })
  }

  async getAntiForgeryToken(): Promise<AntiForgeryToken | void> {
    try {
      const response = await axiosInstance.get<AntiForgeryToken>(
        `${Api.SERVER_DOMAIN + Api.IISSite}/${this.endPoint}/getAntiForgeryToken`
      );
      return response.data;
    } catch (error: any) {
      if (error.ErrorMessage) {
        message.error(error.ErrorMessage);
      }
    }
  }

  updateUserProfile(props: IUserProfile): Promise<void | IResult<string | unknown>> {
    const payload = {
      ...props,
      email: props.userId,
      shipCountry: props.countryId,
      postalcode: props.zipcode,
      vatNumber: props.companyInfo ? props.companyInfo.vatNumber : '',
      zipCode: props.zipcode,
      companyInfo: {
        companyId: props.companyId,
        address1: props.address1,
        address2: props.address2 ? props.address2 : '',
        address3: props.address3 ? props.address3 : '',
        city: props.city,
        postalcode: props.zipcode,
        countryId: props.countryId ? props.countryId.toString() : '',
        stateId: props.stateId ? props.stateId.toString() : '',
        sizeId: props.sizeId ? props.sizeId.toString() : '',
        segmentId: props.segmentId ? props.segmentId.toString() : '',
        vatNumber: props.companyId ? props.companyId : '',
        phone: props.phone ? props.phone : '',
      },
    };

    return axiosInstance
      .post<IResult<string | unknown>>(
        `/${this.endPoint}/UpdateUserProfile`,
        payload
      )
      .then((d) => d.data)
      .catch((error) => {
        if (error.ErrorMessage) {
          message.error(error.ErrorMessage);
        }
      });
  }
}
